import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m)

        // UI
        this.$el = this.el
        this.$buttons = this.$('button')
        this.$items = this.$('item')
        this.$separatorsY = this.$('separatorsY')[0]
        this.$separatorsX = this.$('separatorsX')[0]

        // Data
        this.filterActive = "all"
        this.selectedItems = []

        // Bind
        this.onClickBind = this.onClick.bind(this)
        this.onResizeBind = this.onResize.bind(this)
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents()

        const maxSeparatorsY = this.$items.length - 1
        for (let index = 0; index < maxSeparatorsY; index++) {
            const $span = document.createElement('span');
            this.$separatorsY.appendChild($span);
        }

        requestAnimationFrame(() => {
            this.filterJob()
        })
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        for (let index = 0; index < this.$buttons.length; index++) {
            const $button = this.$buttons[index];
            $button.addEventListener('click', this.onClickBind)
        }

        window.addEventListener('resize', this.onResizeBind)
    }

    unbindEvents() {
        for (let index = 0; index < this.$buttons.length; index++) {
            const $button = this.$buttons[index];
            $button.removeEventListener('click', this.onClickBind)
        }

        window.removeEventListener('resize', this.onResizeBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onClick(e) {
        const $target = e.target
        this.filterActive = e.target.dataset.id

        for (let index = 0; index < this.$buttons.length; index++) {
            const $button = this.$buttons[index];

            if ($button === $target) {
                $button.classList.add('is-active')
            } else {
                $button.classList.remove('is-active')
            }
        }

        this.filterJob()
    }

    onResize() {
        this.setSeparators()
    }

    ///////////////
    // Methods
    ///////////////
    setSeparators() {
        const widths = []
        const heights = []

        for (let index = 0; index < this.selectedItems.length; index++) {
            const $item = this.selectedItems[index];
            widths.push($item.offsetWidth)
            heights.push($item.offsetHeight)
        }

        const offsetX = Math.max(...widths)
        const offsetY = Math.max(...heights)

        this.$el.style.setProperty("--offset-x", `${offsetX - 1}px`)
        this.$el.style.setProperty("--offset-y", `${offsetY}px`)

        let lines = 0
        if (window.innerWidth > 1200) {
            const itemsByLine = 3
            lines = Math.ceil(this.selectedItems.length / itemsByLine)
        } else if (window.innerWidth > 700) {
            const itemsByLine = 2
            lines = Math.ceil(this.selectedItems.length / itemsByLine)
        } else {
            const itemsByLine = 1
            lines = Math.ceil(this.selectedItems.length / itemsByLine)
        }

        const $separatorsYSpans = this.$separatorsY.querySelectorAll('span')
        for (let index = 0; index < $separatorsYSpans.length; index++) {
            const $span = $separatorsYSpans[index];
            if (index > lines - 2) {
                $span.style.display = "none"
            } else {
                $span.style = ""
            }
        }
    }

    filterJob() {
        this.selectedItems = []

        for (let index = 0; index < this.$items.length; index++) {
            const $item = this.$items[index];
            const itemFilters = $item.dataset.ids
            const filters = itemFilters.split(',')

            if (this.filterActive === 'all') {
                $item.classList.remove('-unactive')
                this.selectedItems.push($item)
            } else if (filters.indexOf(this.filterActive) > -1) {
                $item.classList.remove('-unactive')
                this.selectedItems.push($item)
            } else {
                $item.classList.add('-unactive')
            }
        }

        const $staticTiles = this.el.querySelectorAll(".-is-custom")
        const $lastStatic = $staticTiles[$staticTiles.length - 1]
        $lastStatic.classList.remove('-unactive')
        this.selectedItems.push($lastStatic)

        this.$el.style.setProperty("--items", this.selectedItems.length)

        this.setSeparators()

        this.call('update', null, 'Scroll')
    }
}